<template>
    <div class="xc-upload">
        <slot></slot>
        <xc-input-file
            :fileList.sync="data"
            :url="url"
            :multiple="multiple"
            :accept="accept"
            :dataName="dataName"
            :beforeUpload="beforeUpload"
            :uploadSuccess="uploadSuccess"
            :name="inputName"
            v-if="type == 0 || type == 1"
            class="xc-upload-header"
        >
            <template v-slot:input-before>
                <slot name="input-before"></slot>
            </template>
            <template v-slot:input>
                <slot name="input"></slot>
            </template>
            <template v-slot:input-after>
                <slot name="input-after"></slot>
            </template>
        </xc-input-file>
        <slot name="upload-list">
            <!-- 文件上传 -->
            <div
                class="xc-upload-list xc-upload-list-file"
                v-if="type == 0 && files.length"
            >
                <div
                    class="xc-upload-item xc-upload-item-file"
                    v-for="(item,index) in files"
                    :key="index"
                >
                    <div
                        class="xc-upload-item-close xc-close"
                        @click.prevent="del(index)"
                    ></div>
                    <a
                        class="xc-upload-item-title"
                        :href="item[dataName]"
                        target="_blank"
                    >{{item.name}}</a>
                    <div
                        class="xc-upload-progress-bar"
                        v-if="item.status && item.status != 'success'"
                    >
                        <div
                            class="xc-upload-percentage"
                            :style="{width:item.percentage+'%'}"
                            :class="{'xc-upload-percentage-uploading':item.status=='uploading','xc-upload-percentage-success':item.status=='success','xc-upload-percentage-fail':item.status=='fail'}"
                        ></div>
                    </div>
                    <div
                        class="xc-upload-status"
                        v-if="item.status != 'success'"
                    >
                        <span v-if="item.status == 'uploading'">{{item.percentage}}%</span>
                        <span v-if="item.status == 'success'">上传完成</span>
                        <span v-if="item.status == 'fail'">上传失败</span>
                    </div>
                </div>
            </div>
            <!-- 图片上传 -->
            <div
                class="xc-upload-list xc-upload-list-image"
                v-if="type ==1 && files.length"
            >
                <a
                    v-for="(item,index) in files"
                    class="xc-upload-item xc-upload-item-image"
                    :href="item[dataName]"
                    target="_blank"
                    :key="index"
                >
                    <div class="xc-upload-image">
                        <img :src="item[dataName] || item.file">
                    </div>
                    <div
                        class="xc-upload-uploading"
                        v-if="item.status && item.status != 'success'"
                    >
                        <div
                            class="xc-upload-progress-bar"
                            v-if="item.status"
                        >
                            <div
                                class="xc-upload-percentage"
                                :style="{width:item.percentage+'%'}"
                                :class="{'xc-upload-percentage-uploading':item.status=='uploading','xc-upload-percentage-success':item.status=='success','xc-upload-percentage-fail':item.status=='fail'}"
                            ></div>
                        </div>
                        <div class="xc-upload-status">
                            <span v-if="item.status == 'uploading'">正在上传</span>
                            <span v-if="item.status == 'success'">上传完成</span>
                            <span v-if="item.status == 'fail'">上传失败</span>
                        </div>
                    </div>

                    <div
                        class="xc-upload-item-close xc-close"
                        @click.prevent="del(index)"
                    ></div>
                </a>
            </div>
            <!-- 单图上传 -->
            <div
                class="xc-upload-list xc-upload-list-image"
                v-if="type ==3"
            >
                <xc-input-file
                    :fileList.sync="data"
                    :url="url"
                    :multiple="multiple"
                    :accept="accept"
                    :dataName="dataName"
                    :beforeUpload="beforeUpload"
                    :uploadSuccess="uploadSuccess"
                    :name="inputName"
                >
                    <template v-slot:input-before>
                        <slot name="input-before"></slot>
                    </template>
                    <template v-slot:input>
                        <template v-if="type ==3 && files.length">
                            <a
                                v-for="(item,index) in files"
                                class="xc-upload-item xc-upload-item-image"
                                :key="index"
                                style="margin-top:0;"
                            >
                                <div class="xc-upload-image">
                                    <img :src="item[dataName] || item.file">
                                    <div class="xc-upload-item-edit">编辑</div>
                                </div>
                                <div
                                    class="xc-upload-uploading"
                                    v-if="item.status && item.status != 'success'"
                                >
                                    <div
                                        class="xc-upload-progress-bar"
                                        v-if="item.status"
                                    >
                                        <div
                                            class="xc-upload-percentage"
                                            :style="{width:item.percentage+'%'}"
                                            :class="{'xc-upload-percentage-uploading':item.status=='uploading','xc-upload-percentage-success':item.status=='success','xc-upload-percentage-fail':item.status=='fail'}"
                                        ></div>
                                    </div>
                                    <div class="xc-upload-status">
                                        <span v-if="item.status == 'uploading'">正在上传</span>
                                        <span v-if="item.status == 'success'">上传完成</span>
                                        <span v-if="item.status == 'fail'">上传失败</span>
                                    </div>

                                </div>
                                <div
                                    class="xc-upload-item-close xc-close"
                                    @click.prevent="del(index)"
                            ></div>
                            </a>
                        </template>
                        <template v-else>
                            <a class="xc-upload-item xc-upload-item-image" style="margin-top:0;">
                                <div class="xc-upload-image xc-upload-image-add"></div>
                            </a>
                        </template>
                    </template>
                    <template v-slot:input-after>
                        <slot name="input-after"></slot>
                    </template>
                </xc-input-file>

            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'XcUpload',
    inheritAttrs: false,
    props: {
        inputName:{
            default: null,
        },
        type: {
            default: 1,
        },
        // 上传前
        beforeUpload: {
            type: Function,
            default: () => {

            }
        },
        // 上传成功
        uploadSuccess: {
            type: Function,
            default: () => {
            }
        },
        // 上传的文件列表, 例如: [{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]
        fileList: {
            default: () => {
                return [];
            },
        },
        multiple: {},
        fieldname: {},
        url: {},
        dataName: {
            default: 'file'
        },
        accept: {},
    },
    components: {},
    data() {
        return {
            error: null,
            loading: false,
            index: 0,
            data: [],
        }
    },
    created() {
        this.data = this.fileList;
    },
    computed: {
        // 将data转化成filse的格式
        files() {
            return this.fileList || [];
        }
    },
    watch: {
        fileList(v) {
            this.data = v;
        },
        data(v) {
            this.$emit('update:fileList', v);
        }
    },
    methods: {
        del(index) {
            const files = [
                ...this.data,
            ]

            files.splice(index, 1);
            this.$emit('update:fileList', files);
        },
    }
}
</script>

<style scoped lang="scss">
</style>
